export { }

window.global ||= window;

function detectBrowserSupported() {
    if (window.navigator.userAgent.match(/(MSIE|Trident|Edge)/)) {
        return false;
    }

    // These checks indicate a minimum of Chrome/Edge 119, Safari 17.4, and Firefox 128.
    return CSS.supports('color', 'rgb(from red r g b)') && typeof AbortSignal.any === 'function';
}

if (!detectBrowserSupported()) {
    document.body.style.fontFamily = 'Source Sans Pro';
    document.body.style.fontSize = '1.125rem';
    document.body.style.fontWeight = '400';

    const container = document.getElementById('root');

    const html = `<div style="padding: 1em; position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%); text-align: center;">
        <h1 style="font-weight: 300; line-height: 1.2; margin-bottom: 0.5rem;">
            This browser is no longer supported.
        </h1>
        <p>
            Your browser is not supported by this application. Please use an up to date version of one of the following browsers: Edge, Chrome, Firefox or Safari.
        </p>
    </div>`;

    if (container) {
        container.innerHTML = html;
    }
}
else {
    import("./mainApp").then(function (mainApp) {
        mainApp.loadApp();
    });
}